import styled from "styled-components";

export const WinTextCasino777Box = styled.div`
    @media ${({theme}) => theme.mediaQuery.lAndAbove} {
        font-size: 2rem;
        width: 230px;
    }
    text-transform: uppercase;
    font-size: 1.4rem;
    color: #BC3554;
    @media ${({theme}) => theme.mediaQuery.portrait} {
        text-align: center;
    }
`;